import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { extractApiError } from "../api/apiErrorHandler";
import { getDashbordDetails } from "api/dashboardApi";

const initialState = {
  dashboardData: {},
  dashboardLoading: false,
  dashboardError: null,
};

// 🔹 Get Dashboard
export const getDashbord = createAsyncThunk(
  "orders/getDashbord",
  async (data, thunkAPI) => {
    try {
      return await getDashbordDetails(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashbord.pending, (state) => {
        state.dashboardLoading = true;
        state.dashboardError = null;
      })
      .addCase(getDashbord.fulfilled, (state, action) => {
        state.dashboardLoading = false;
        state.dashboardError = null;
        state.dashboardData = action.payload;
      })
      .addCase(getDashbord.rejected, (state, action) => {
        state.dashboardLoading = false;
        state.dashboardError = action.payload;
      });
  },
});

export default dashboardSlice.reducer;
